/* byliox Voice – Designsystem. Tokens und Schriften stammen von byliox.dev; Hell-Variante ist neu. */

@font-face {
  font-family: 'Archivo';
  src: url('./fonts/archivo-variable.woff2') format('woff2');
  font-weight: 100 900;
  font-stretch: 62% 125%;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'IBM Plex Mono';
  src: url('./fonts/plex-mono-400.woff2') format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'IBM Plex Mono';
  src: url('./fonts/plex-mono-500.woff2') format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

:root {
  --font-sans: 'Archivo', 'Helvetica Neue', Arial, sans-serif;
  --font-mono: 'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, monospace;

  /* Dunkel (Standard, identisch mit byliox.dev) */
  --bg-primary: #0c1015;
  --bg-secondary: #121820;
  --bg-elevated: #19212a;

  --text-primary: #ebedeb;
  --text-secondary: #b0b8bc;
  --text-muted: #87929a;

  --border-primary: rgba(235, 237, 235, 0.18);
  --border-subtle: rgba(235, 237, 235, 0.09);

  --accent: #f47745;
  --accent-hover: #ff9164;
  --accent-foreground: #11151a;
  --accent-text: #f47745;

  --status-ok: #5fae86;
  --status-busy: #d46a6a;

  --ease-out: cubic-bezier(0.22, 0.61, 0.24, 1);
  --dur-fast: 150ms;
  --dur-base: 220ms;

  --sidebar-width: 240px;

  color-scheme: dark;
}

:root[data-theme='dark'] {
  color-scheme: dark;
}

:root[data-theme='light'] {
  --bg-primary: #f4f3ef;
  --bg-secondary: #eceae4;
  --bg-elevated: #ffffff;

  --text-primary: #11151a;
  --text-secondary: #3d464d;
  --text-muted: #5f6a72;

  --border-primary: rgba(17, 21, 26, 0.16);
  --border-subtle: rgba(17, 21, 26, 0.08);

  --accent-hover: #e0652f;
  --accent-text: #c4501f;

  --status-ok: #2f7d58;
  --status-busy: #b04545;

  color-scheme: light;
}

/* „System“: gleiche Hell-Werte, aber nur wenn das Betriebssystem Hell wünscht. */
@media (prefers-color-scheme: light) {
  :root[data-theme='system'] {
    --bg-primary: #f4f3ef;
    --bg-secondary: #eceae4;
    --bg-elevated: #ffffff;

    --text-primary: #11151a;
    --text-secondary: #3d464d;
    --text-muted: #5f6a72;

    --border-primary: rgba(17, 21, 26, 0.16);
    --border-subtle: rgba(17, 21, 26, 0.08);

    --accent-hover: #e0652f;
    --accent-text: #c4501f;

    --status-ok: #2f7d58;
    --status-busy: #b04545;

    color-scheme: light;
  }
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: var(--font-sans);
  font-size: 1rem;
  line-height: 1.5;
  font-stretch: 100%;
  font-variant-numeric: tabular-nums;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

h1,
h2,
h3,
p,
dl,
dd,
figure,
ol,
ul {
  margin: 0;
}

ol,
ul {
  padding: 0;
  list-style: none;
}

a {
  color: inherit;
  text-decoration: none;
}

button,
input,
select,
textarea {
  font: inherit;
  color: inherit;
}

::selection {
  background: var(--accent);
  color: var(--accent-foreground);
}

:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 3px;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-delay: 0ms !important;
    transition-duration: 0.01ms !important;
    transition-delay: 0ms !important;
  }
}
